import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  concat,
  ApolloLink,
} from '@apollo/client'

import AppConfig from './AppConfig'

export const jwtRef = {
  /** @type {string | null} */
  current: null,
}

export const apolloClient = () => {
  const httpLink = createHttpLink({ uri: AppConfig.APOLLO_CLIENT })

  const authMiddleware = new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    operation.setContext(({ headers = {} }) => {
      return {
        headers: {
          ...headers,
          ...(jwtRef.current ? { authorization: jwtRef.current } : {}),
        },
      }
    })

    return forward(operation)
  })

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: concat(authMiddleware, httpLink),
    connectToDevTools: true,
    name: 'retailer',
  })

  return client
}
